import React from "react"
import { useSortable } from "@dnd-kit/sortable"
import { ResizableColumn } from "./resizable-column"
import { useDragIndex, DragIndexState } from "../contexts/drag-context"

export interface HeaderCellProps extends React.HTMLAttributes<HTMLTableCellElement> {
    id: string
}

export interface BodyCellProps extends React.HTMLAttributes<HTMLTableCellElement> {
    id: string
}

const dragActiveStyle = (dragState: DragIndexState, id: string): React.CSSProperties => {
    const { active, over } = dragState
    let style: React.CSSProperties = {}
    if (active && active === id) {
        style = { backgroundColor: "gray", opacity: 0.5 }
    } else if (over && id === over && active !== over) {
        style = { borderInlineStart: "1px dashed gray" }
    }
    return style
}

export const TableBodyCell: React.FC<BodyCellProps> = (props) => {
    const { dragIndex } = useDragIndex()
    return <td {...props} style={{ ...props.style, ...dragActiveStyle(dragIndex, props.id) }} />
}

const fixedSizeCells = ["ant-table-selection-column", "ant-table-row-expand-icon-cell"] as const

export const TableHeaderCell: React.FC<HeaderCellProps> = (props) => {
    const { dragIndex } = useDragIndex()
    const { attributes, listeners, setNodeRef, isDragging } = useSortable({ id: props.id })

    if (fixedSizeCells.some((antdClassName) => props.className?.includes(antdClassName))) {
        return <th {...props} />
    }

    const style: React.CSSProperties = {
        ...props.style,
        ...(isDragging ? { position: "relative", zIndex: 9999, userSelect: "none" } : {}),
        ...dragActiveStyle(dragIndex, props.id)
    }

    const dragAreaProps = {
        ...attributes,
        ...listeners,
        style: {
            cursor: "move",
            ...(isDragging ? { cursor: "grabbing" } : {})
        }
    }

    return <ResizableColumn {...props} ref={setNodeRef} style={style} dragAreaProps={dragAreaProps} />
}
